import { render, staticRenderFns } from "./mi-contrasena.vue?vue&type=template&id=4f00faca&lang=html"
import script from "./mi-contrasena.vue?vue&type=script&lang=js"
export * from "./mi-contrasena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports